import { useState } from 'react';
import {
  selectAboutTLW,
  selectClause,
  selectCustomerService,
} from '../../../api';
import { useFooterData } from '../../../hooks';
import { ServiceItem, type ServiceItemProps } from './ServicItem';

export function ServiceList() {
  const footerData = useFooterData();
  const data: ServiceItemProps[] = [
    { id: 'aboutTLW', title: '關於特力屋 ', items: selectAboutTLW(footerData) },
    {
      id: 'customerService',
      title: '顧客服務',
      items: selectCustomerService(footerData),
    },
    { id: 'clause', title: '條款說明', items: selectClause(footerData) },
  ];

  // 維護當前打開的菜單id
  const [activeMenu, setActiveMenu] = useState<string | null>(null);

  // 切換菜單
  const changeMenu = (id: string) => {
    // 若當前已展開則關閉，否則打開
    setActiveMenu(activeMenu === id ? null : id);
  };

  return (
    <div className="tlw-block tlw-gap-20 md:tlw-flex">
      {data.map((item) => (
        <ServiceItem
          key={item.id}
          activeMenu={activeMenu}
          changeMenu={changeMenu}
          {...item}
        />
      ))}
    </div>
  );
}
